export default __webpack_public_path__ + "static/media/5_bottom.725f02f1.png";